export default __webpack_public_path__ + "static/media/logo-beta.c44e805e.svg";